import React from 'react'
import { useAccessCard } from '../../../ContextProvider/Accesscardprovider'
import { useNavigate } from 'react-router-dom';
import { getCurrentUserDetail, getUserDocId } from '../../../Localstorage';
import { upsertResultData } from '../../../Firebase/Course-fb';

const Quizsubmit = () => {
  const { accessCard, accessQuizSubmit, time, answer, marks, timeLeft, head, question, quizCode } = useAccessCard();
  const navigate = useNavigate();
  const quizSubmit = async () => {
    accessQuizSubmit();
    accessCard();
    // const data = { time, answer, marks, timeLeft, head, question };
    // sessionStorage.setItem("quizScoreData", JSON.stringify(data));


    // sessionStorage.setItem("quizTime", time);
    // sessionStorage.setItem("quizAnswer", JSON.stringify(answer)); // array, so stringify
    // sessionStorage.setItem("quizMarks", marks);
    // sessionStorage.setItem("quizTimeLeft", timeLeft);
    // sessionStorage.setItem("quizHead", head);
    // sessionStorage.setItem("quizQuestions", JSON.stringify(question)); // array, so stringify

    const setWithExpiry = (key, value) => {

      const item = {
        value: value
      };

      localStorage.setItem(key, JSON.stringify(item));
    };
    const marks = JSON.parse(sessionStorage.getItem("qquizMarks"));
    const quizData = {
      quizTime: time,
      quizAnswer: JSON.stringify(answer),
      quizMarks: marks,
      quizTimeLeft: timeLeft,
      quizHead: head,
      quizQuestions: JSON.stringify(question),
    };
    // setWithExpiry(String(quizCode), quizData, 60 * 1000); // 1 minute = 60,000 ms
    setWithExpiry("Quiz", quizData)
    const studentResult = {
      student_name: getCurrentUserDetail()[0].name,
      student_id: getUserDocId(),
      quiz_code: sessionStorage.getItem("quizCode"),
      quiz_name: head,
      correct_answered: marks,
      wrong_answered: (answer.length - answer.filter(item => item === null).length) - marks,
      un_answered: answer.filter(item => item === null).length,
      attempt_count: 18,
      time_taken: (time * 60) - timeLeft, // in seconds
      actual_time: time * 60, // in seconds
      time_stamp: Date.now(), // Unix timestamp (ms)
      question_list: question,
      answer_list: answer
    };
    await upsertResultData(getUserDocId(),sessionStorage.getItem("quizCode"),studentResult)

    navigate("/quiz-score");
  }
  return (
    // <div className="modal-overlay">
    <div className="modal-content">
      <h2 className="modal-title">SUBMIT QUIZ</h2>
      <p className="modal-text">Are you sure, want to submit quiz?</p>
      <div className="modal-buttons">
        <button className="cancel-btn" onClick={() => { accessQuizSubmit(); accessCard(); }}>
          Cancel
        </button>
        <button className="submit-btn" onClick={quizSubmit}>
          Submit
        </button>
      </div>
    </div>
    // </div>
  )
}

export default Quizsubmit